import { BaseResponse } from '../data/types';
import { Curve, Sample } from './../samples/types';

export enum System {
  AIRBRINE = 'Air-Brine',
  AIROIL = 'Air-Oil',
  OILBRINE = 'Oil-Brine',
  AIRHG = 'Air-Hg'
}

export interface Well {
  uid: string;
  well_name: string;
  date: string | null;
  startIndex: number | null;
  endIndex: number | null;
  step: number | null;
  curves: Curve[];
  project_uid: string;
  color: string | null;
  version: number;
}

export interface WellData {
  wellId: string;
  sampleId: string;
  sampleCode: string;
}

export interface WellPayload {
  well_name?: string;
  samples: Sample[];
  curves: [];
  project_uid?: string;
  well_uid?: string;
}

export type WellSelected = {
  wellId: string;
  projectId: string;
  well_name: string;
};

export interface AddWellPayload {
  project_uid: string;
  well_name: string;
  date?: string;
  startIndex?: number;
  endIndex?: number;
  step?: number;
  curves: Curve[];
  color?: string;
}

export interface UpdateWellPayload {
  project_uid?: string;
  well_uid: string;
  well_name: string;
  date?: string;
  startIndex?: number;
  endIndex?: number;
  step?: number;
  color?: string;
}

export interface AddWellResponse extends BaseResponse {
  content: Well;
}

export interface UpdateWellResponse extends BaseResponse {
  content: Well;
}

export interface DeleteWellResponse extends BaseResponse {}

export interface ListWellsResponse extends BaseResponse {
  content: Well[];
}
